import ciraReport from './CIRAReport/ciraReportStore';
import ciraPreCalcReport from './CIRAPreCalcReport/ciraPreCalcReportStore';

export default {
  namespaced: true,
  modules: {
    ciraReport,
    ciraPreCalcReport,
  },
};